import styled from "styled-components/macro";
import { CssFlex } from "styles/helpers/layout";

export const StyledSYCheckBoxWrapper = styled(CssFlex)`
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;
